export const normalizeCustomerForCart = (customer) => {
    const addresses = customer?.addresses?.map((addr) => ({
        ...addr,
        firstName: addr.firstName ?? "",
        lastName: addr.lastName ?? "",
        city: addr.city ?? "",
        country: addr.country ?? "",
        street: addr.street ?? "",
        postalCode: addr.postalCode ?? "",
        phone: addr.phone ?? undefined,
        email: addr.email ?? undefined,
        meta: Array.isArray(addr.meta) ? addr.meta : [],
    })) ?? [];
    const birthDate = customer && "birthDate" in customer ? customer.birthDate : undefined;
    const { companyName, ...customerWithoutCompanyName } = customer ?? {};
    return {
        ...customerWithoutCompanyName,
        phone: customer?.phone ?? undefined,
        email: customer?.email ?? undefined,
        birthDate: birthDate ?? undefined,
        addresses,
        meta: customer?.meta && Array.isArray(customer?.meta) ? customer.meta : [],
        ...(companyName ? { companyName } : {}),
    };
};
